import { Component, OnInit, ViewChild } from '@angular/core';
import { AccessRole, AlertIcon, AlertService, ButtonColumnType, CustomAlertComponent, CustomTableComponent, CustomTitle, DataColumnType, FormGroupErrorMessageComponent, ICustomTable, LoadingPanelService, LocalService, noWhitespaceValidator, Utils } from 'lib-base';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin, lastValueFrom } from 'rxjs';
import { IGetTipos } from '../../../../shared/interfaces/database/pqrsd';
import { TiposService } from '../../../../services/database/pqrsd/tipos.service';
import { PqrdsConfiguracionActividadesByTipoComponent } from './pqrds-configuracion-actividades-by-tipo/pqrds-configuracion-actividades-by-tipo.component';
import { DialogModule } from 'primeng/dialog';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { DropdownModule } from 'primeng/dropdown';
import { PqrsdTiposHistorialComponent } from './pqrsd-tipos-historial/pqrsd-tipos-historial.component';
import { CheckboxModule } from 'primeng/checkbox';

@Component({
  selector: 'app-pqrsd-tipos',
  standalone: true,
  imports: [CustomTableComponent, ConfirmPopupModule, DialogModule, CustomTitle, ReactiveFormsModule, ButtonModule, CommonModule,
    PqrdsConfiguracionActividadesByTipoComponent, FormGroupErrorMessageComponent, InputTextModule, InputNumberModule, CustomAlertComponent,
    DropdownModule, PqrsdTiposHistorialComponent, CheckboxModule
  ],
  providers: [ConfirmationService],
  templateUrl: './pqrsd-tipos.component.html',
  styleUrl: './pqrsd-tipos.component.scss'
})
export class PqrsdTiposComponent implements OnInit {

  role = AccessRole;
  trans: any = {};
  //Form Modal
  formTitle = '';
  displayModal = false;
  form !: FormGroup;
  private _editValue !: IGetTipos | undefined;
  private _originalValues: any;
  iconos: { name: string, code: string }[] = [
    { name: 'Queja', code: 'ico-servi-queja.png' },
    { name: 'Peticion', code: 'ico-servi-peticion.png' },
    { name: 'Reclamo', code: 'ico-servi-reclamo.png' },
    { name: 'Sugerencia', code: 'ico-servi-sugerex.png' },
    { name: 'Denuncia', code: 'ico-servi-denuncia.png' },
    { name: 'Felicitacion', code: 'ico-servi-felicitax.png' }
  ];
  get isNewForm(): boolean {
    return this._editValue === undefined;
  }

  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  @ViewChild(PqrsdTiposHistorialComponent) historico !: PqrsdTiposHistorialComponent;

  constructor(private readonly _t: TranslateService, private readonly _ts: TiposService, private readonly _lps: LoadingPanelService,
    public ls: LocalService, private readonly _fb: FormBuilder, private readonly _cs: ConfirmationService, private readonly _ms: MessageService,
    private readonly _als: AlertService) {
    this.configureForm();
  }

  ngOnInit(): void {
    this.translate().then(() => this.configTable());
    this.getTipos();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      icono: this._t.get('common.icono'),
      descripcion: this._t.get('common.descripcion'),
      plazo: this._t.get('common.plazo'),
      produccion: this._t.get('common.produccion'),
      limpiar: this._t.get('form.button.limpiar'),
      guardar: this._t.get('form.button.guardar'),
      nombre: this._t.get('common.nombre'),
      editarTipoPQRSD: this._t.get('msg.editarTipoPQRSD'),
      estasSeguroEliminarTipoPQRSD: this._t.get('msg.estasSeguroEliminarTipoPQRSD'),
      nuevaTipoPQRSD: this._t.get('msg.nuevaTipoPQRSD'),
      tipoCreado: this._t.get('msg.tipoCreado'),
      tipoActualizado: this._t.get('msg.tipoActualizado'),
      tipoEliminado: this._t.get('msg.tipoEliminado'),
      tipo: this._t.get('common.tipo'),
      publicadoPortal: this._t.get('components.app-admin-tramites.app-admin-tipo-tramite.publicado-portal-tramite'),
      buttonCerrar: this._t.get('form.button.cerrar'),
      registroActualizado: this._t.get('msg.registroActualizado'),
      requiereDocumentoRespuesta: this._t.get('common.requiereDocumentoRespuesta'),
      advertencia: this._t.get('common.advertencia'),
      asignacionManual: this._t.get('msg.asignacionManual'),
      noCambiosFormulario: this._t.get('msg.noCambiosFormulario'),
      completeCamposRequeridos: this._t.get('msg.completeCamposRequeridos'),
    }));
  }

  private configTable() {
    this.customTable = {
      settings:{
        table:{
          rows: 8,
        }
      },
      columns: [
        {
          field: 'expand',
          header: '',
          class: 'p-button-info',
          width: '0.5rem',
          buttonType: ButtonColumnType.EXPANDED
        },
        {
          field: 'nombre',
          header: this.trans.nombre,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          columnFilter: true,
          width: '20rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'descripcion',
          header: this.trans.descripcion,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          columnFilter: true,
          width: '40rem',
          truncate: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'plazo',
          header: this.trans.plazo,
          width: '20rem',
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'icono',
          header: this.trans.icono,
          width: '20rem',
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'requiereDocumentoRespuesta',
          header: this.trans.requiereDocumentoRespuesta,
          width: '6rem',
          dataType: DataColumnType.CHECK,
        },
        {
          field: 'produccion',
          header: this.trans.produccion,
          sort: true,
          class: 'button-edit p-button-outlined',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          width: '20rem',
          buttonType: ButtonColumnType.CHECK,
          onClick: (event: Event, data: IGetTipos) => this.cambiarEstadoProduccion(data),
        },
        {
          field: 'abrir',
          header: '',
          icon: 'pi pi-history',
          class: 'button-edit p-button-outlined pt-2 pb-2 pr-1 pl-0',
          width: '0rem',
          severity: 'info',
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: Event, data: IGetTipos) => this.abrirHistorial(data),
        },
        {
          field: 'edit',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pl-1 pr-1',
          buttonType: ButtonColumnType.EDIT,
          disabled: !this.ls.hasRole(this.role.ADMIN_PQRSD),
          tooltip: {
            message: this.trans.requiereRolSeguridad
          },
          onClick: (event: Event, data: IGetTipos) => this.openEditModal(data),
          headerBtn: {
            icon: 'pi pi-history',
            class: 'pt-2 pb-2 pl-0 pr-1',
            severity: 'info',
            onClick: (event: Event) => this.abrirHistorialEliminado(),
          }
        },
        {
          field: 'delete',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pl-1 pr-0',
          buttonType: ButtonColumnType.DELETE,
          disabled: !this.ls.hasRole(this.role.ADMIN_PQRSD),
          tooltip: {
            message: this.trans.requiereRolSeguridad
          },
          onClick: (event: Event, data: IGetTipos) => this.deleteConfirmation(event, data),
          headerBtn: {
            icon: 'pi pi-plus',
            class: 'pt-2 pb-2 pl-1 pr-0',
            onClick: (event: Event) => this.openNewModal(),
            disabled: !this.ls.hasRole(this.role.ADMIN_PQRSD),
          },
          headerTooltip: {
            message: this.trans.requiereRolSeguridad,
            disabled: this.ls.hasRole(this.role.ADMIN_PQRSD)
          }
        }
      ],
    } as ICustomTable;
  }

  private cambiarEstadoProduccion(data: IGetTipos) {
    this.setProduccion(data.id, !data.produccion).then(() => {
      if (!data.produccion) {
        this._als.show({
          data: {
            showIcon: false,
            icon: AlertIcon.SUCCESS,
            title: '',
            html: `
         <div class="w-30rem">
            <h2 class="text-gray uppercase">${this.trans.tipo}</h2>
            <h2 class="uppercase">${data.nombre}</h2>
            <p class="text-2xl mb-2">${this.trans.publicadoPortal}</p>
         </div>
        `,
            showAccept: true,
            positionBtn: 'right',
            acceptButton: {
              label: this.trans.buttonCerrar,
              class: 'border-rounded-xl bg-indigo-600 hover:bg-indigo-400',
            }
          },
          autoClose: true,
          breakpoints: {
            '1600px': '30vw',
            '1400px': '40vw',
            '960px': '50vw',
            '640px': '90vw'
          },
          position: 'top-right',
        });
      } else {
        this._ms.add({ severity: 'info', summary: this.trans.registroActualizado });
      }
    });
  }

  abrirHistorial(data: IGetTipos): void {
    this.historico.show(data.id);
  }

  abrirHistorialEliminado(): void {
    this.historico.showEliminado();
  }

  //#region Form
  resetForm() {
    this.form.reset();
  }

  configureForm() {
    this.form = this._fb.group({
      nombre: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(100)]],
      descripcion: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(255)]],
      plazo: [1, [Validators.required, Validators.min(1)]],
      icono: [null, [Validators.required, Validators.maxLength(50)]],
      requiereDocumentoRespuesta: [false, [Validators.required]],
      asignacionManual: [false, [Validators.required]]
    });
  }

  openNewModal() {
    this.resetForm();
    this.formTitle = this.trans.nuevaTipoPQRSD;
    this._editValue = undefined;
    this.displayModal = true;
    this.form.get('requiereDocumentoRespuesta')?.setValue(false);
    this.form.get('asignacionManual')?.setValue(false);
  }

  openEditModal(data: IGetTipos) {
    this.resetForm();
    this.formTitle = this.trans.editarTipoPQRSD;
    this._editValue = data;
    this.form.get('nombre')?.setValue(data.nombre);
    this.form.get('descripcion')?.setValue(data.descripcion);
    this.form.get('plazo')?.setValue(data.plazo);
    this.form.get('icono')?.setValue(data.icono);
    this.form.get('requiereDocumentoRespuesta')?.setValue(data.requiereDocumentoRespuesta);
    this.form.get('asignacionManual')?.setValue(data.asignacionManual);
    this.displayModal = true;
    this._originalValues = { ...this.form.value };
  }

  deleteConfirmation(event: Event, data: IGetTipos) {
    this._cs.confirm({
      target: event.target as EventTarget,
      message: this.trans.estasSeguroEliminarTipoPQRSD,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteTipo(data.id);
      },
      reject: () => {

      }
    });
  }

  onSubmit() {
    if (this.form.pristine) {
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.noCambiosFormulario });
      return;
    }

    if (this.form.invalid) {
      Utils.markAllFormControlsAsTouched(this.form);
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.completeCamposRequeridos });
      return;
    }

    const newValues = {
      nombre: this.form.get('nombre')?.value,
      descripcion: this.form.get('descripcion')?.value,
      plazo: this.form.get('plazo')?.value,
      icono: this.form.get('icono')?.value,
      requiereDocumentoRespuesta: this.form.get('requiereDocumentoRespuesta')?.value,
      asignacionManual: this.form.get('asignacionManual')?.value
    } as IGetTipos;

    if (this.isNewForm) {
      this.createTipo(newValues);
    } else if (!Utils.isDeepEqual(this._originalValues, newValues)) {
      this.updateTipo(newValues);
    } else {
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.noCambiosFormulario });
    }
  }

  //#endregion

  //#region API calls
  getTipos(): void {
    this._ts.getTipos().subscribe({
      next: (data: IGetTipos[]) => {
        this.customTableComponent.data = data;
      },
    });
  }

  createTipo(tipo: IGetTipos) {
    this._lps.show(true);
    this._ts.createTipo(tipo).subscribe({
      next: (response: number) => {
        this._lps.hide();
        this._ms.add({ severity: 'success', summary: 'Éxito', detail: this.trans.tipoCreado });
        this.getTipos();
        this.displayModal = false;
      },
    });
  }

  updateTipo(tipo: IGetTipos) {
    if (!this._editValue) return;
    this._lps.show(true);
    this._ts.updateTipo(this._editValue.id, tipo).subscribe({
      next: (response: boolean) => {
        this._lps.hide();
        this._ms.add({ severity: 'success', summary: 'Éxito', detail: this.trans.tipoActualizado });
        this.getTipos();
        this.displayModal = false;
      }
    });
  }

  deleteTipo(id: number) {
    this._lps.show(true);
    this._ts.deleteTipo(id).subscribe({
      next: (response: boolean) => {
        this._lps.hide();
        this._ms.add({ severity: 'success', summary: this.trans.exito, detail: this.trans.tipoEliminado });
        this.getTipos();
      }
    });
  }

  async setProduccion(id: number, produccion: boolean) {
    this._lps.show(true);
    return await lastValueFrom(this._ts.setProduccion(id, produccion))
      .then((response: boolean) => {
        this._lps.hide();
        this.getTipos();
      });
  }
  //#endregion
}
